import * as React from "react";
const SortUp = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M11.4931464,4.99807161 L11.4963,5.00207161 L11.4998,4.9992 L12.2069068,5.70630678 L12.2043,5.70807161 L15.7423,9.2412 L15.0351932,9.94830678 L11.9993,6.91707161 L12,18.9992 L11.0003,18.9992 L11.0003,6.91207161 L7.96440678,9.94830678 L7.2573,9.2412 L10.7893,5.70907161 L10.7860396,5.70517839 L11.4931464,4.99807161 Z" }));
SortUp.displayName = "SortUp";
var SortUp_default = SortUp;
export {
  SortUp_default as default
};
